import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import Configs from "../config"
import moment from "moment"
import React, { useEffect, useMemo, useState } from "react"
import {
  FaChevronCircleLeft,
  FaChevronCircleRight,
  FaEye,
  FaPen,
  FaPlus,
  FaSearch,
  FaUser,
} from "react-icons/fa"
import { FaCircleCheck, FaPerson } from "react-icons/fa6"
import { MdDelete, MdSave } from "react-icons/md"
import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
  Button,
} from "reactstrap"
import Swal from "sweetalert2"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"

const HelpSection = () => {
  const { checkAccess } = usePermissionData()

  const [loading, setLoading] = useState(false)
  const [perPageItem, setPerPageItem] = useState(10)
  const [searchString, setSearchString] = useState("")
  const [currentPage, setCurrentPage] = useState(1)

  const [helpData, setHelpData] = useState([])
  const [selectedItemId, setSelectedItemId] = useState("")
  const [helpItem, setHelpItem] = useState({
    title: "",
    media: null,
    type: "",
  })
  const [errors, setErrors] = useState({})
  const [modalType, setModalType] = useState(0)
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    fetchHelpData()
  }, [])

  async function fetchHelpData() {
    const APIdata = await fetchData(setLoading, "help")
    if (APIdata?.success) {
      setHelpData(APIdata?.data?.reverse())
    } else {
      setHelpData([])
      console.log("Error Fetching Records", APIdata?.response)
    }
  }

  // 🔍 Filter + Paginate location
  const filteredData = useMemo(() => {
    return helpData?.filter(
      loc =>
        loc.title.toLowerCase().includes(searchString.toLowerCase()) ||
        loc.type.toLowerCase().includes(searchString.toLowerCase())
    )
  }, [helpData, searchString])

  const totalPages = Math.ceil(filteredData.length / perPageItem)

  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * perPageItem
    return filteredData.slice(start, start + perPageItem)
  }, [filteredData, currentPage, perPageItem])

  const handleSave = async () => {
    const newErrors = {}

    if (!helpItem?.title?.trim()) {
      newErrors.title = "Video title is required"
    }

    if (!helpItem?.type) {
      newErrors.type = "Video type is required"
    }

    // Required only when adding
    if (!selectedItemId && !helpItem?.media) {
      newErrors.media = "Video file is required"
    }

    // ❌ Stop if errors exist
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }

    // ✅ Clear errors
    setErrors({})

    let APIdata
    if (selectedItemId) {
      APIdata = await FetchPutData(setLoading, "help", selectedItemId, helpItem)
    } else {
      APIdata = await FetchPostData(setLoading, "help", helpItem)
    }

    if (APIdata?.data?.success) {
      Swal.fire({
        title: `Video ${selectedItemId ? "Updated" : "Added"} Successfully.`,
        text: APIdata?.data?.message,
        icon: "success",
      })
      setHelpItem({
        title: "",
        media: null,
        type: "",
      })
      setShowModal(false)
      fetchHelpData()
    } else {
      Swal.fire({
        title: `Something Went Wrong`,
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  const handleDelete = async (id, name) => {
    const result = await Swal.fire({
      title: "Are You Sure?",
      text: `You want to delete ${name} this Video`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3d6eb6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it",
    })

    if (result.isConfirmed) {
      try {
        const APIdata = await FetchDeleteData(setLoading, "help", id)

        if (APIdata?.data) {
          await Swal.fire({
            title: "Video Deleted Successfully.",
            icon: "success",
          })
          fetchHelpData()
        } else {
          Swal.fire({
            title: "Something Went Wrong",
            text: APIdata?.response?.data?.message || "Please try again later.",
            icon: "error",
          })
        }
      } catch (err) {
        Swal.fire({
          title: "Error",
          text: err?.message || "Failed to delete Video.",
          icon: "error",
        })
      }
    }
  }

  const [employeeModal, setEmployeeModal] = useState(false)
  const [selectedHelp, setSelectedHelp] = useState([])

  return (
    <div className="page-content">
      <PermittedComponent isAccess={checkAccess(11, 1) || checkAccess(11, 2)}>
        <Container fluid>
          <Breadcrumb
            title="Dashboard"
            breadcrumbItem="Help Section"
            description="Manage the all Video Guidance from here"
          />
          {loading && <Loader />}
          <Row>
            <Col lg="12" className="px-0 h-100">
              <Card className="mb-0 shadow-lg">
                <CardBody>
                  {/* Header Controls */}
                  <div className="d-flex justify-content-between">
                    <div className="d-flex gap-3">
                      <select
                        className="form-select rounded-4 ps-3 pe-5 w-auto"
                        value={perPageItem}
                        onChange={e => {
                          setPerPageItem(Number(e.target.value))
                          setCurrentPage(1)
                        }}
                      >
                        <option value={10}>Show 10</option>
                        <option value={20}>Show 20</option>
                        <option value={50}>Show 50</option>
                      </select>

                      <div className="position-relative">
                        <input
                          className="form-control rounded-4 px-3 pe-5"
                          placeholder="Search Video"
                          value={searchString}
                          onChange={e => setSearchString(e.target.value)}
                        />
                        <span className="position-absolute end-0 top-50 translate-middle-y pe-3 text-muted">
                          <FaSearch />
                        </span>
                      </div>
                    </div>

                    {checkAccess(11, 3) && (
                      <div className="d-flex gap-3">
                        <Button
                          className="btn-blue"
                          onClick={() => {
                            setSelectedItemId("")
                            setHelpItem({})
                            setModalType(1)
                            setShowModal(true)
                          }}
                        >
                          <FaPlus className="me-2" /> Video
                        </Button>
                      </div>
                    )}
                  </div>

                  {/* Location Table */}
                  <div className="mt-5">
                    <Table responsive hover>
                      <thead className="bg-blue text-white">
                        <tr>
                          <th>#</th>
                          <th>Video Title</th>
                          <th>Video Type</th>

                          <th className="text-center">Created At</th>
                          <th className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.length > 0 ? (
                          paginatedData.map((loc, index) => (
                            <tr key={loc.id}>
                              <td>
                                {(currentPage - 1) * perPageItem + index + 1}
                              </td>
                              <td>{loc?.title}</td>
                              <td>
                                {loc?.type === "Admin"
                                  ? "Admin Panel"
                                  : "Mobile Application"}
                              </td>

                              <td className="text-center">
                                {moment(loc?.createdAt).format("DD-MM-YYYY")}
                              </td>

                              <td className="d-flex justify-content-center flex-nowrap">
                                <Button
                                  size="sm"
                                  className="me-2 btn-blue"
                                  onClick={() => {
                                    setSelectedHelp(loc)
                                    setEmployeeModal(true)
                                  }}
                                >
                                  <FaUser size={14} />
                                </Button>
                                <Button
                                  size="sm"
                                  className="me-2 btn-blue"
                                  onClick={() => {
                                    setHelpItem(loc)
                                    setSelectedItemId(loc.id)
                                    setModalType(0)
                                    setShowModal(true)
                                  }}
                                >
                                  <FaEye size={14} />
                                </Button>
                                {checkAccess(11, 4) && (
                                  <Button
                                    color="success"
                                    size="sm"
                                    className="me-2"
                                    onClick={() => {
                                      setHelpItem(loc)
                                      setSelectedItemId(loc.id)
                                      setModalType(2)
                                      setShowModal(true)
                                    }}
                                  >
                                    <FaPen size={14} />
                                  </Button>
                                )}
                                {checkAccess(11, 5) && (
                                  <Button
                                    color="danger"
                                    size="sm"
                                    onClick={() =>
                                      handleDelete(loc.id, loc.title)
                                    }
                                  >
                                    <MdDelete size={14} />
                                  </Button>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center text-muted">
                              No Videos found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {/* Pagination */}
                  <div className="d-flex justify-content-between  gap-2">
                    <p className="mb-0">
                      Showing {paginatedData.length} out of {helpData.length}{" "}
                      Locations.
                    </p>
                    <div>
                      <Button
                        size="sm"
                        disabled={currentPage === 1}
                        className="fs-6"
                        onClick={() => setCurrentPage(prev => prev - 1)}
                      >
                        <FaChevronCircleLeft />
                      </Button>
                      {Array.from({ length: totalPages }, (_, i) => (
                        <Button
                          key={i}
                          size="sm"
                          className="mx-2 fs-6"
                          color={currentPage === i + 1 ? "primary" : "light"}
                          onClick={() => setCurrentPage(i + 1)}
                        >
                          {i + 1}
                        </Button>
                      ))}
                      <Button
                        size="sm"
                        className="fs-6"
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage(prev => prev + 1)}
                      >
                        <FaChevronCircleRight />
                      </Button>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal
          isOpen={showModal}
          toggle={() => setShowModal(false)}
          centered
          size="lg"
        >
          <ModalHeader toggle={() => setShowModal(false)}>
            {modalType === 0
              ? "View Video"
              : modalType === 1
              ? "Add Video"
              : "Edit Video"}
          </ModalHeader>
          <ModalBody>
            {modalType === 0 && (
              <div>
                <video
                  width="100%"
                  height="auto"
                  controls
                  controlsList="nodownload"
                  style={{ borderRadius: "8px" }}
                  src={`${Configs.imageUrl}${helpItem.media}`}
                >
                  Your browser does not support the video tag.
                </video>
              </div>
            )}
            {(modalType === 1 || modalType === 2) && (
              <>
                <Row>
                  <Col md={8}>
                    <label>
                      Video Title <span className="text-danger">*</span>
                    </label>
                    <input
                      className={`form-control ${
                        errors.title ? "is-invalid" : ""
                      }`}
                      placeholder="Enter Video Title"
                      value={helpItem?.title}
                      onChange={e =>
                        setHelpItem(prev => ({
                          ...prev,
                          title: e.target.value,
                        }))
                      }
                    ></input>
                    {errors.title && (
                      <div className="invalid-feedback">{errors.title}</div>
                    )}
                  </Col>
                  <Col md={4}>
                    <label>
                      Video Type <span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-select rounded-4 ${
                        errors.type ? "is-invalid" : ""
                      }`}
                      placeholder="Enter Video Type"
                      value={helpItem?.type}
                      onChange={e =>
                        setHelpItem(prev => ({ ...prev, type: e.target.value }))
                      }
                    >
                      <option value={""}>Select Video Type</option>
                      <option value={"Admin"}>Admin Panel</option>
                      <option value={"Mobile"}>Mobile Application</option>
                    </select>
                    {errors.type && (
                      <div className="invalid-feedback d-block">
                        {errors.type}
                      </div>
                    )}
                  </Col>
                  <Col md={12} className="mt-3">
                    <label>
                      Video File <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      accept="video/*"
                      className={`form-control ${
                        errors.media ? "is-invalid" : ""
                      }`}
                      placeholder="Enter Video File"
                      onChange={e => {
                        const file = e.target.files?.[0]

                        if (!file) return

                        if (!file.type.startsWith("video/")) {
                          Swal.fire(
                            "Invalid File Selected",
                            "Please Select Video File Only",
                            "error"
                          )
                          e.target.value = "" // reset input
                          return
                        }

                        setHelpItem(prev => ({
                          ...prev,
                          media: file,
                        }))
                      }}
                    ></input>
                    <p className="mb-0">
                      Uploaded File:{" "}
                      <span className="fw-bold">
                        {helpItem?.media
                          ? typeof helpItem.media === "string"
                            ? helpItem.media.split("/").pop() // API link
                            : helpItem.media.name // Selected file
                          : "No file selected"}
                      </span>
                    </p>

                    {errors.media && (
                      <div className="invalid-feedback d-block">
                        {errors.media}
                      </div>
                    )}
                  </Col>
                </Row>
                <div className=" mt-3">
                  <Button color="primary" onClick={() => handleSave()}>
                    <MdSave /> Save
                  </Button>
                </div>
              </>
            )}
          </ModalBody>
        </Modal>

        <Modal
          isOpen={employeeModal}
          toggle={() => setEmployeeModal(false)}
          centered
          size="lg"
        >
          <ModalHeader toggle={() => setEmployeeModal(false)}>
            Employee's Who Watched the Video
          </ModalHeader>
          <ModalBody>
            <Table
              striped
              className="bg-white"
              style={{
                maxHeight: "450px",
                overflowY: "scroll",
                scrollbarWidth: "thin",
              }}
            >
              <thead>
                <tr>
                  <td>#</td>
                  <td>Employee Name</td>
                </tr>
              </thead>
              <tbody>
                {selectedHelp?.employees?.length === 0 && (
                  <tr className="">
                    <td className="text-center" colSpan={3}>
                      No Employees Found
                    </td>
                  </tr>
                )}
                {selectedHelp?.employees?.map((item, index) => (
                  <tr className="" key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.name}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ModalBody>
        </Modal>
      </PermittedComponent>
    </div>
  )
}

export default HelpSection
